/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState, useCallback } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const usePesquisaStatus = (formikRef, valores = [], config = {}, onFilterChange) => {
  const { salvarLocalStorage = false, chave } = config;
  const pesquisaSelectStatus = useSelect("pesquisa");

  const [pesquisa, setPesquisa] = useState(0);
  const [fila, setFila] = useState(null);
  const [dados, setDados] = useState(valores || []);
  const [initialized, setInitialized] = useState(false);

  // Evita atualizações desnecessárias dos dados
  useEffect(() => {
    if (JSON.stringify(valores) !== JSON.stringify(dados)) {
      setDados(valores || []);
    }
  }, [valores]);

  const optionsPesquisaStatus = useMemo(
    () => prepareForOptions(dados, ["label"], "value"),
    [dados]
  );

  const pesquisasObjId = useMemo(
    () => createObj({ key: "value", data: dados, prefix: "key-" }),
    [dados]
  );

  const pesquisasObjCodigo = useMemo(
    () => createObj({ key: "value", data: dados }),
    [dados]
  );

  const pesquisasObjNome = useMemo(
    () => createObj({ key: "label", data: dados }),
    [dados]
  );

  function createObj({ key = "value", data = [], prefix = "" }) {
    if (Array.isArray(data)) {
      return data.reduce((acc, cur) => {
        acc[`${prefix}${cur[key]}`] = cur;
        return acc;
      }, {});
    }
    return {};
  }

  // useCallback para evitar recriação da função
  const onChangePesquisaStatus = useCallback((e) => {
    pesquisaSelectStatus.upDateValue(e.value);
    pesquisaSelectStatus.upDateDefaultValue(e || "");
    formikRef?.current?.setFieldValue("status", e.value);

    if (salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }

    onFilterChange((prev) => ({
      ...prev,
      status: e.value,
    }));

    setTimeout(() => formikRef?.current?.setFieldTouched("status", true));
    setPesquisa(e.value);
  }, [salvarLocalStorage, chave, onFilterChange, formikRef, pesquisaSelectStatus]);

  // Efeito para inicialização do localStorage - executa apenas uma vez
  useEffect(() => {
    if (salvarLocalStorage && !initialized) {
      const pesquisaSalva = localStorage.getItem(chave);
      if (pesquisaSalva) {
        const pesquisaObj = JSON.parse(pesquisaSalva);
        setPesquisa(pesquisaObj.value);
        setFila(pesquisaObj.value);
      }
      setInitialized(true);
    }
  }, [salvarLocalStorage, chave, initialized]);

  // Efeito separado para processar a fila quando options estiverem prontos
  useEffect(() => {
    if (fila && optionsPesquisaStatus?.length > 0 && initialized) {
      const pesquisa = optionsPesquisaStatus.find((p) => p.value === fila);
      if (pesquisa) {
        // Usa setTimeout para evitar atualização síncrona durante render
        setTimeout(() => {
          onChangePesquisaStatus(pesquisa);
        });
      }
      setFila(null);
    }
  }, [fila, optionsPesquisaStatus, initialized, onChangePesquisaStatus]);

  function setSelectPesquisa(id) {
    if (optionsPesquisaStatus?.length > 0) {
      const pesquisa = optionsPesquisaStatus.find((p) => p.value === id);
      if (pesquisa) onChangePesquisaStatus(pesquisa);
      setFila(null);
    } else {
      setFila(id);
    }
  }

  return {
    optionsPesquisaStatus,
    dados,
    fila,
    onChangePesquisaStatus,
    setSelectPesquisa,
    pesquisa,
    pesquisaSelectStatus,
    pesquisasObjId,
    pesquisasObjCodigo,
    pesquisasObjNome,
  };
};

export default usePesquisaStatus;